import React, { useRef,forwardRef,useImperativeHandle,useState, useEffect } from "react";

import Preliminary from "./preliminary/preliminary";
import NycProject from "./nycproject/nycproject";
import Homeowner from "./homeowner/homeowner";
import Permitting from "./permitting/permitting";
import PVSystem from "./pvsystem/pvsystem";
import TaskDependencyMapping from "./TaskDependencyMapping";
import ProjectService from "../../../../common/util/ProjectService";
import AwsServerService from "../../../../common/util/AwsServerService";
import { message } from "antd";
const Layout = forwardRef((props,ref) => {
  const [addressValChange, setAddressValChange] = useState(false);
  const [state, setState] = useState(false);
  const [templateData, setTemplateData] = useState({Services:[],DealRelatedData:[]});
  const [dealDeps, setDealDeps] = useState({deps:[],ROWIDs:[]});
  useEffect(()=>{ 
    let obj=JSON.parse(localStorage.getItem('data'));
    AwsServerService.getPipelineTemplateNames().then(res1=>{ 
        setTemplateData((prev)=>{return {...prev,Services:res1[0]}});
    AwsServerService.getPipelineDataByDeal(obj.Deal_Name).then(res=>{
      setTemplateData((prev)=>{return {...prev,DealRelatedData:res}}); 
    })
  })
  },[])
  useEffect(()=>{
    if(state){
      let obj=JSON.parse(localStorage.getItem('data'));
      let newServices = obj?.Service_Requested.filter(rec=>rec.hasOwnProperty('module'));
      let rowIds = templateData.Services?.filter(rowid=>newServices.some(e=>e.id==rowid?.ServiceId));
      let ids= rowIds.map(e=>e.ROWID).join(',');
      ProjectService.getDepsForDealPipelines(ids).then(res=>{
        setDealDeps({deps:res.data,ROWIDs:ids});
        if(res.data.length==0){
          localStorage.setItem("dependencyCloningData", JSON.stringify({Approved:[],Rejected:[]}))
        }
        ProjectService.getInternalDepsForPipelines(ids).then(res=>{
          localStorage.setItem("dependencyInternalCloningData", JSON.stringify(res.data))
        }).catch(er=>message.error('Error getting data for internal dependencies withing Pipelines(Services)!'))
      }).catch(er=>{
        setDealDeps({deps:[],ROWIDs:[]});
        localStorage.setItem("dependencyInternalCloningData", JSON.stringify([]))
        localStorage.setItem("dependencyCloningData", JSON.stringify({Approved:[],Rejected:[]}))
      })
    }
  },[state])
  //Hrushikesh shelke new code
  const saveCancelButtonRef = useRef();
  useImperativeHandle(ref, () => ({
    saveButtonClick() {
      let currentsidebar=localStorage.getItem("currentsidebar");
            if(props.sidebarCardsStatus.Preliminary && props.sidebarCardsStatus.NavActivetab!='Preliminary'){
                if((props.sidebarCardsStatus.NycProject && props.sidebarCardsStatus.NavActivetab!='NycProject') || props.sidebarCardsStatus.SkipNycFlag){
                    if(props.sidebarCardsStatus.Homeowner && props.sidebarCardsStatus.NavActivetab!='Homeowner'){
                        if(props.sidebarCardsStatus.Permitting && props.sidebarCardsStatus.NavActivetab!='Permitting'){
                            if(props.sidebarCardsStatus.PVSystem && props.sidebarCardsStatus.NavActivetab!='PVSystem'){
                              saveCancelButtonRef.current.savePVSystem();
                            }else{
                              saveCancelButtonRef.current.savePVSystem();
                            }
                        }else{
                          saveCancelButtonRef.current.savePermitting();
                        }
                    }else{
                      saveCancelButtonRef.current.saveHomeowner();
                    }
                }else{
                  saveCancelButtonRef.current.saveNycProject();
                }
            }else{
              if(props.location.state.action == "Update"){
                setState(true);
              }
              saveCancelButtonRef.current.savePreliminary();
            }
    },
    toggelActiveBar(d) {
      saveCancelButtonRef.current.toggelActiveBar(d);
    }
  }));
  //hrushikesh shelke new code

  return (
    <div className="color-white">
      {<TaskDependencyMapping state={state} setState={setState} MainData={templateData.DealRelatedData} DepsData={dealDeps}/>}
      {
        props.layoutstate == "preliminary" ? (
          <Preliminary
            ref={saveCancelButtonRef}
            sidebarCardsStatus={props.sidebarCardsStatus}
            updateTheSidebarState={props.updateTheSidebarState}
            allServicesName={props.allServicesName}
            setAllServicesName={props.setAllServicesName}
            allDeals={props.allDeals}
            setData={props.setData}
            setEntityId={props.setEntityId}
            buttonPosition={props.buttonPosition}
            setButtonPosition={props.setButtonPosition}
            isAccess={props.isAccess}
            selectedRole={props.selectedRole}
            addressValChange={addressValChange}
            setAddressValChange={setAddressValChange}
            func={props.func}
            getProjectNumber={props.getProjectNumber}
            handleOnChangeDeal={props.handleOnChangeDeal}
            refreshDeal={props.refreshDeal}
            data={props.data}
            listState={props.listState}
            layoutstate={props.layoutstate}
            setLayoutState={props.setLayoutState}
            setListState={props.setListState}
            setNycVisible={props.setNycVisible}
            isNycVisible={props.isNycVisible}
          />
        ) : props.layoutstate == "nycproject" ? (
          <NycProject
            ref={saveCancelButtonRef}
            sidebarCardsStatus={props.sidebarCardsStatus}
            setSidebarCardsStatus={props.setSidebarCardsStatus} 
            updateTheSidebarState={props.updateTheSidebarState}
            setData={props.setData}
            location={props.location}
            getDealData={props.getDealData}
           isAccess={props.isAccess}
            selectedRole={props.selectedRole}
            addressValChange={addressValChange}
            setAddressValChange={setAddressValChange}
            handleOnChangeDeal={props.handleOnChangeDeal}
            data={props.data}
            refreshDeal={props.refreshDeal}
            listState={props.listState}
            layoutstate={props.layoutstate}
            setLayoutState={props.setLayoutState}
            setListState={props.setListState}
            setNycFilingDisable={props.setNycFilingDisable}
            nycFilingDisable={props.nycFilingDisable}
            setownerType={props.setownerType}
            setLoader={props.setLoader}
          />
        ) : props.layoutstate == "homeowner" ? (
          <Homeowner
            ref={saveCancelButtonRef}
            sidebarCardsStatus={props.sidebarCardsStatus}
            updateTheSidebarState={props.updateTheSidebarState}
            isAccess={props.isAccess}
            selectedRole={props.selectedRole}
            handleOnChangeDeal={props.handleOnChangeDeal}
            refreshDeal={props.refreshDeal}
            setMailAddressDisable={props.setMailAddressDisable}
            mailAddressDisable={props.mailAddressDisable}
            data={props.data}
            listState={props.listState}
            layoutstate={props.layoutstate}
            setLayoutState={props.setLayoutState}
            setListState={props.setListState}
            setownerType={props.setownerType}
          />
        ) : props.layoutstate == "permitting" ? (
          <Permitting
            ref={saveCancelButtonRef}
            sidebarCardsStatus={props.sidebarCardsStatus}
            updateTheSidebarState={props.updateTheSidebarState}
            isAccess={props.isAccess}
            selectedRole={props.selectedRole}
            handleOnChangeDeal={props.handleOnChangeDeal}
            refreshDeal={props.refreshDeal}
            data={props.data}
            listState={props.listState}
            layoutstate={props.layoutstate}
            setLayoutState={props.setLayoutState}
            setListState={props.setListState}
          />
        ) :
          <PVSystem
            ref={saveCancelButtonRef}
            sidebarCardsStatus={props.sidebarCardsStatus}
            updateTheSidebarState={props.updateTheSidebarState}
            entityId={props.entityId}
            buttonPosition={props.buttonPosition}
            isAccess={props.isAccess}
            location={props.location}
            selectedRole={props.selectedRole}
            ClickSaveSave={props.ClickSaveSave}
            handleOnChangeDeal={props.handleOnChangeDeal}
            refreshDeal={props.refreshDeal}
            data={props.data}
            listState={props.listState}
            layoutstate={props.layoutstate}
            setLayoutState={props.setLayoutState}
            setListState={props.setListState}
          />

      }

    </div>
  );
});

export default Layout;